import React, { useState } from "react"
import QuestionDialog from "./QuestionDialog";
import ResultDialog from "./ResultDialog";
import { trackPromise } from "react-promise-tracker";
import { GETTING_STARTED_DEFAULT_ANSWER, IMPLEMENTATION_TYPE_RESULT } from "_constants/CertificationTestingConstants";

const Questionnaire = (props) => {

    const {
        api,
        certificationPackageAction,
        handleTableData,
        isToggled,
        product,
        setLoading,
        questionnaire,
        tableHeaders,
    } = props

    const [answers, setAnswers] = useState(GETTING_STARTED_DEFAULT_ANSWER())
    const [questionNumber, setQuestionNumber] = useState(1)
    const [completed, setCompleted] = useState(false)
    const [implementationType, setImplementationType] = useState(null)
    const [implementationTypeState, setImplementationTypeState] = useState(IMPLEMENTATION_TYPE_RESULT.INVALID)
    const [tableData, setTableData] = useState(
        tableHeaders
    )
    const handleCheckImplementationType = async (submittedAnswers) => {
        // corner case: if the user already has a hosting provider
        if (submittedAnswers[2] === 3) {
            setCompleted(true)
            setImplementationTypeState(IMPLEMENTATION_TYPE_RESULT.IRRELEVANT)
            return
        }
        setLoading(true)
        await trackPromise(
            api(submittedAnswers, product)
                .then((response) => {
                    setImplementationType(response.data.result)
                    if (response.data.result.isValid) {
                        let newtableData = handleTableData(tableData, response.data.result)
                        setTableData(newtableData)
                        setImplementationTypeState(IMPLEMENTATION_TYPE_RESULT.VALID)
                    } else {
                        setImplementationTypeState(IMPLEMENTATION_TYPE_RESULT.INVALID)
                    }
                }).finally(() => {
                    setCompleted(true)
                    setLoading(false)
                }))
    };

    return (
        <>
            {isToggled &&
                (!completed ?
                    <QuestionDialog
                        answers={answers}
                        handleCheckImplementationType={handleCheckImplementationType}
                        questionNumber={questionNumber}
                        questionnaire={questionnaire}
                        setCompleted={setCompleted}
                        setAnswers={setAnswers}
                        setQuestionNumber={setQuestionNumber}
                    />
                    :
                    <ResultDialog
                        answers={answers}
                        isValid={true}
                        implementationType={implementationType}
                        implementationTypeState={implementationTypeState}
                        product={product}
                        setAnswers={setAnswers}
                        setCompleted={setCompleted}
                        certificationPackageAction={certificationPackageAction}
                        setQuestionNumber={setQuestionNumber}
                        questionnaire={questionnaire}
                        tableData={tableData}
                    />
                )
            }
        </>
    )
}

export default Questionnaire